module.exports = __webpack_public_path__ + "882278d71a214e52e54996988490b5ea.jpg";